import CasallProPurchaseMultiSizeInput from '../../Components/CasallPro/CasallProPurchaseMultiSizeInput'
import React from 'react';
import { connect } from 'react-redux';
import { updateData, setDefaultData } from '../../Actions/PurchaseMultiSizeInput.action'

const CasallProPurchaseMultiSizeInputContainer = props => (
    <CasallProPurchaseMultiSizeInput {...props} />
)

const mapStateToProps = state => {
    return {
        sizeData: state.sizeInput.data,
        errors: state.cart.errors
    }
}

const mapDispatchToProps = dispatch => {
    return {
        updateData: (data) => dispatch(updateData(data)),
        setDefaultData: (data) => dispatch(setDefaultData(data))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(CasallProPurchaseMultiSizeInputContainer);
